import { render, staticRenderFns } from "./Twilio.vue?vue&type=template&id=578181f4&lang=pug"
import script from "./Twilio.vue?vue&type=script&lang=js"
export * from "./Twilio.vue?vue&type=script&lang=js"
import style0 from "./Twilio.vue?vue&type=style&index=0&id=578181f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports